<style scope>
  .fonte_11 {
    font-size: 11px
  }
</style>

<template>
  <div>

    <b-table :data="lista" :loading="loading" class="row-button fonte_11"
             :paginated="true" :perPage="20" :default-sort-direction="'asc'"
             default-sort="A1_NOME">
      <portal-lista-vazia slot="empty"/>

      <template slot-scope="props">

        <b-table-column label="Código">
          {{ props.row.A1_COD }}
        </b-table-column>

        <b-table-column label="CNPJ">
          {{ props.row.A1_CGC | cpfcnpj }}
        </b-table-column>

        <b-table-column label="RAZÃO SOCIAL" field="A1_NOME" sortable>
          <b-tooltip :label="props.row.A1_NREDUZ">
            {{ props.row.A1_NOME }}
          </b-tooltip>
        </b-table-column>

        <b-table-column label="Endereço">
          {{ props.row.A1_END }}
        </b-table-column>

        <b-table-column label="Bairro" field="A1_BAIRRO" sortable>
          {{ props.row.A1_BAIRRO }}
        </b-table-column>

        <b-table-column label="Cidade" field="A1_MUN" sortable>
          {{ props.row.A1_MUN }}
        </b-table-column>

        <b-table-column label="UF">
          {{ props.row.A1_EST }}
        </b-table-column>

        <b-table-column label="Telefone">
          {{ (props.row.A1_DDD + props.row.A1_TEL) | telefone }}
        </b-table-column>

        <b-table-column label="Dias p/ inativar" field="DIAS_INATIVIDADE" sortable>
          {{ props.row.DIAS_INATIVIDADE }}
        </b-table-column>
      </template>

    </b-table>

  </div>
</template>

<script>
  export default {
    props: ['lista', 'loading']
  }
</script>



// WEBPACK FOOTER //
// src/pages/cliente/ListaClienteAtivo.vue